(function ($, Drupal) {

  'use strict';
  var cssVariablesResizer;

  Drupal.behaviors.css_variables = {
    attach: function (context, settings) {
      setCssVariables();
    },
  };

  $(window).resize(function () {
    clearTimeout(cssVariablesResizer);
    cssVariablesResizer = setTimeout(setCssVariables, 100);
  });

  function setCssVariables() {
    document.documentElement.style.setProperty('--wrapper-space--width', ($('.wrapper').innerWidth() - $('.container--default').width()) / 2 + "px");
    document.documentElement.style.setProperty('--page-header--height', ($('.page_header').outerHeight() + 'px'));

    if($('.paragraph--hero .links-blocks').length > 0) {
      document.documentElement.style.setProperty('--p-hero--lblocks--height', ($('.paragraph--hero .links-blocks').outerHeight() + 'px'));
    }else{
      document.documentElement.style.setProperty('--p-hero--lblocks--height', '0px');
    }

    document.documentElement.style.setProperty('--page-footer--graphic-top--height', ($('.page_footer .graphic_top').outerHeight() + 'px'));
  }

})(jQuery, Drupal);
